// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ReliableUPS_TheComp__CTTI6"};